import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const TrackAndTrace = lazy(
  () =>
    import('./TrackAndTrace.eager').then(mod => ({
      default: mod.TrackAndTrace,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
